import { render, staticRenderFns } from "./SpreadsheetAutocomplete.vue?vue&type=template&id=08ed8b7c&"
import script from "./SpreadsheetAutocomplete.vue?vue&type=script&lang=js&"
export * from "./SpreadsheetAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./SpreadsheetAutocomplete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VList,VListItem,VListItemContent,VListItemTitle,VTextField})
